'use strict';

exports.SD = require('./SD');
exports.NMR = require('./NMR');
exports.NMR2D = require('./NMR2D');
exports.Ranges = require('./range/Ranges');



//////////////////
// WEBPACK FOOTER
// ./~/spectra-data/src/index.js
// module id = 63
// module chunks = 0